module.exports = "../assets/warning-89c527fd.png";